module.exports = __webpack_public_path__ + "img/key.9f5d3d7f.svg";